import type { FaireThemeEntity } from "../../entity_types/theme";

export const desk_candy_bag_charms: FaireThemeEntity = {
  token: "desk-candy-bag-charms",
  type: "theme",
  retailerToken: "r_rk3595bqqg",
  name: "Desk Candy & Bag Charms",
  description: "Affordable, fun accessories for younger buyers",
  bgColor: "#D4EEF0",
  tileBgColor: "#8a6028",
  productTokens: [
    "p_f4f9ujr2m2",
    "p_es2h8fhr4e",
    "p_xaqb4gnnad",
    "p_xx5hpaakb9",
    "p_6h4zvq5ana",
    "p_y346nrvmkt",
    "p_yt6e2zydfr",
    "p_sfemj7hh82",
    "p_gvdp5nhav8",
    "p_z2k42t3uyu",
    "p_s9y25rn5j5",
    "p_3y3r0w7vnz",
    "p_mxqpsethe7",
    "p_kyp5w3r9bf",
    "p_9uar7wzusu",
    "p_utmw7h67yd",
    "p_2w45azs6ge",
    "p_7d2krzpz6j",
    "p_xnyh5mcvfk",
    "p_darbmubfh4",
    "p_qa248xyjw6",
    "p_9fz2mn76h8",
    "p_b9t6tgt94t",
    "p_bkfpqv4jeh",
  ],
  exactProducts: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:50:10Z",
    importedBy: "retailer-themes-entity-migration",
  },
};
